import DateUtility from './dates';

export const formatCurrencyToHuman = (amount, decimals) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals ? decimals : 0,
  });
  return formatter.format(amount);
};

export const formatStandardDateTime = date => {
  if (date === null) return '';

  return DateUtility.formatDate(date, 'MMMM dd yyyy, h:mm a');
};

export const formatStandardDate = date => {
  if (date === null) return '';
  return DateUtility.formatDate(date, 'MMMM dd, yyyy');
};

export const formatShortDate = date => {
  if (date === null) return '';
  return DateUtility.formatDate(date, 'M/d/yyyy');
}
